import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/all", label: "电影分类" },
    { to: "/category/tvseries", label: "电视剧" },
    { to: "/category/variety", label: "综艺" },
    { to: "/category/animation", label: "动漫" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/95 backdrop-blur-md shadow-lg"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold tracking-wide" style={{
              fontFamily: "var(--font-heading)",
              color: scrolled ? "oklch(var(--primary-500))" : "oklch(var(--foreground-50))",
            }}>
              🌸 春夜影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? "bg-primary-500/20 text-primary-500"
                    : scrolled
                    ? "text-foreground-300 hover:text-primary-400 hover:bg-background-800"
                    : "text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
                scrolled
                  ? "text-foreground-400 hover:text-foreground-200 hover:bg-background-800"
                  : "text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10"
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10"
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="pb-4 max-w-[1400px] mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影、电视剧、综艺..."
                className="w-full px-4 py-3 pl-12 rounded-lg bg-background-800 border border-background-700 text-foreground-200 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors text-sm"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-lg"></i>
            </div>
          </div>
        )}

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-800">
            <div className="flex flex-col gap-1 pt-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.to
                      ? "bg-primary-500/20 text-primary-500"
                      : "text-foreground-300 hover:text-primary-400 hover:bg-background-800"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}